/** @module csi/view/CompositeSplitter */
define([
	"dojo/_base/declare",
	"dojo/query",
	"csi/_base/underscore",
	"csi/html",
	"csi/printUtil"
], function(declare,query,_,html,printUtil) {

// Example DOM structure of composite view
//	<div data-csi-print-splitter="composite">
//		<div class="csiPageBlock">
//			<div class="csi-view galleryView" data-csi-print-splitter="gallery">
//			</div>
//		</div>
//		<div class="csiPageBlock">
//			<div class="csi-view tableViewRoot" data-csi-print-splitter="table">
//			</div>
//		</div>
//	</div>
	
	html.registerDataAttribute("DATA_VIEW_SPLIT", "view-split", Number);

	function _getDataViewSplit(block) {
		return (html.getDataAttribute(block, html.DATA_VIEW_SPLIT) != null) ? [block] : query(html.getDataAttributeSelector(html.DATA_VIEW_SPLIT), block);
	}

	var Splitter = declare(null, {
		/** @property {boolean} bNewPageBlocks - check for views that have splitters but are not encapsulated in a csiPageBlock div */
		bNewPageBlocks: true,

		/**
		 * Split composite view content so it fits nicely on pages with given width and height
		 * @param {DOMNode[]} aPages
		 * @param {DOMNode} viewRoot
		 * @param {number} nPageHeight
		 * @param {number} nPageWidth
		 * @param {Function} [copyCallback] - function called when child view is copied from one page to another
		 */
		split: function(aPages, viewRoot, nPageHeight, nPageWidth, copyCallback) {
			var cssQuery = "." + html.CSS_PAGE;
			var ePage = aPages.last();
			var blocks;
			var block;
			var objViews = {};
			var nBlock;
			var nView = 0;
			var blockParent;
			var eCopy;
			var copiedBlocks;

			function startFromNewPage() {
				// summary: Moved the block indicated by blockCounter to the next page.
				var blockNode = block.get(0);
				var pageBlocks = $(ePage).find(cssQuery);

				// If block is the only block on the current page, then leave where it is - moving to another
				// page will just cause the same problem. The use case for this is one page Review where the property
				// view is short enough to be combined with the first canvas page. See csi/datasheet/widget#_postView.
				if ((pageBlocks.length == 1) && (pageBlocks[0] == blockNode)) {
					return;
				}

				block.remove();
				eCopy = html.cloneElement(ePage);
				copiedBlocks = $(eCopy).find(cssQuery);
				blockParent = copiedBlocks[0].parentNode;
				copiedBlocks.remove();
				blockParent.appendChild(blockNode);
				ePage.parentNode.appendChild(eCopy);
				aPages.push(eCopy);
			}

			// If copyCallback is defined, it means one of the child views in the Datasheet is of type Html
			// in which case we just need to do basic logic if it needs to be moved to a new page.
			if (copyCallback) {
				if (Math.floor(nPageHeight) < Math.floor(ePage.offsetHeight)) {
					// the current page's contents are bigger than the paper height, so move the last block (html view) to the next page.
					blocks = query(cssQuery, ePage);
					block = $(blocks[blocks.length - 1]);
	
					if (!block.hasClass(html.CSS_PAGE_BREAK)) {
						startFromNewPage();
					}
				}

				return;
			}

			// no need to split if everything fits on page
			var contentWidth = printUtil.getContentWidth();
			var contentHeight = ePage.offsetHeight;
			
			if ((contentWidth <= nPageWidth) && (contentHeight <= nPageHeight)) {
				return;
			}

			function copyChildCallback(viewNode, viewNodeCopy) {
				// when we are fitting two tables partially in one page, we don't want to keep
				// the first table in the newly copied page.
				$(viewNodeCopy).find(cssQuery + ":not(:last-child)").remove();
			}

			function splitBlockView(views) {
				// summary: split view in block if possible
				return _.some(views, function(eView) {
					var i = html.getDataAttribute(eView, html.DATA_VIEW_SPLIT);
					var viewNode = objViews[i];
					if (viewNode) {
						printUtil.splitContent(aPages, viewNode, copyChildCallback);
						objViews[i] = null;
						return true;
					}

					return false;
				});
			}

			query("." + html.CSS_VIEW, viewRoot).forEach(function(viewNode) {
				var e = html.getParentByClassName(viewNode, html.CSS_PAGE);
				var splitterType = html.getDataAttribute(viewNode, html.PRINT_SPLITTER);
				
				if (e || (splitterType && this.bNewPageBlocks)) {
					if (!e) {
						// if view not within page block, then make it one
						// FIX: Is this ever a valid case?
						e = viewNode;
						$(e).addClass(html.CSS_PAGE);
					}
					
					html.setDataAttribute(e, html.DATA_VIEW_SPLIT, nView);
					objViews[nView++] = viewNode;
				}
			}, this);

			function shouldStartFromNewPage(nViews, blockCounter) {
				// This method decides whether we need to start from a new page.
				// At the moment, this logic only applies to Canvas and Gallery blocks
				// FIXME: 	For tables, this logic is being handled in csi/table/Splitter.
				// 			Fix this inconsistency for different block types in composite views.
				var bForcePageBreak = html.getDataAttribute(block, html.PRINT_BREAK);
				return (bForcePageBreak || block.hasClass(html.CSS_PAGE_BREAK) || !nViews) && blockCounter != 0 && block.html().length > 0;
			}

			var lastPageBlocks;
			var views;

			// each block is a section in the composite view. e.g. properties is one block, each table
			// after that is a block.
			blocks = query(cssQuery, ePage);
			nBlock = blocks.length;

			if (nBlock > 1) {
				for (var blockCounter = 0 ; blockCounter < nBlock ; blockCounter++) {
					ePage = aPages.last();
					block = $(blocks[blockCounter]);
					views = _getDataViewSplit(block.get(0));
	
					// if block has csiPageBreak class or it doesn't have any element with html attribute "[data-csi-view-split]"
					// and it's not the first block, then move the block to a new page.
					if (shouldStartFromNewPage(views.length, blockCounter)) {
						startFromNewPage();
					} else {
						lastPageBlocks = $(ePage).find(cssQuery);
	
						blockParent = lastPageBlocks[0].parentNode;
	
						//remove every block except the current ones.
						$(ePage).find(cssQuery + ":not(.csi-split-current-block)").remove();
	
						blockParent.appendChild(block.get(0));
					}
	
					block.addClass("csi-split-current-block");
	
					splitBlockView(views);
				}
			} else {
				// we have only one block, so just pass it to splitter like normal tables.
				views = _getDataViewSplit(blocks[0]);
				splitBlockView(views);
			}
		}
	});

	printUtil.registerViewSplitter("composite", Splitter);

	return Splitter;
});
